let enCreditsText = "Credits";
if (window.sessionStorage.getItem("MODULEDATA")) {
    enCreditsText = JSON.parse(window.sessionStorage.getItem("MODULEDATA")).creditNameEn || "Credits";
}
/***
 * 星展银行特殊处理
 * aon积分名称修改“iFlex积分” 英文“iFlex Credits
   节日积分名称修改为员工俱乐部积分，英文“Club Credits”
 * ***/
let aon = 'iFlex '
let festival = 'Festival '
let ordinary = 'Ordinary '

let iFlex =JSON.parse(sessionStorage.getItem('MODULEDATA'))? JSON.parse(sessionStorage.getItem('MODULEDATA')).iFlex : ''
if(iFlex){
  aon = 'iFlex'
  festival = 'Club'
  ordinary = 'Other  '

}


export const message = {
  ordinary:ordinary,
   festival:festival,
  confirm_order_tip1:'Because the address information is adjusted, please edit the "region" option in the current delivery address again, and you can place the order smoothly!',
  confirm_order_btn1:'To perfect',
    weiNiInternational:'Vinie supply chain',
  FrequentlyAskedQuestions:'common Questions',
  FrequentlyAskedQuestions_weini:'Frequently asked questions on cross-border goods',
    integralBuckle:enCreditsText+' can be low',
  paymentQuestion: 'Payment question',//支付疑问
  containsFees:'Contains the taxes and fees',
  troubleShooting:'trouble shooting',
  shipAddress: 'place of dispatch',
  paymentQuestionTitle1: 'mode of despatch',
  paymentQuestionTitle2: 'expenses of taxation',
  paymentQuestionTitle3: 'fuli deduction',
  paymentQuestionCon1: 'Cross-border goods shipped through overseas or bonded warehouses will be divided into bonded warehouses at different gateways according to different conditions of the goods.The timeliness of receiving goods will also be different',
  paymentQuestionCon2: 'The purchase of overseas goods shall be declared and taxed to the Chinese customs in accordance with the law',
  paymentQuestionCon3: 'Fuqiu commodities are supplied by a variety of suppliers, some of which are shipped directly from overseas warehouses, according to the declaration conditions of the Chinese customs.Payment order, logistics order, order number information (goods, payment amount, etc.) must be declared through the customs.',
  paymentQuestionCon4:'If you encounter some goods can only deduct part of the amount, please understand the inconvenience brought to you!',
  attention_tip1:'Pay attention to the public number to buy goods again',
  attention_tip2:'follow the Wechat official account',
  attention_tip3:'You have followed the public account',
  attention_tip4:'This product is deductible',
  attention_tip5:'Unsubscribe will no longer be eligible！',
  pay_attention_to:'Pay attention to',
  money_z:'￥',
  focus_on_relief:'Focus on relief',
  has_been_cut:'Has been cut',
  attention_tip6: 'Commodity purchase province',
  attention_tip7: 'Purchase goods expected to save',
  attention_tip8:'WeChat scan qr code to follow the public, this product can be immediately reduced',
  info_tip3: '· does not support 7 days without reason to return or replace goods · id card verification · cash payment',
  shopCart01: 'The item you selected contains international items',
  shopCart02: 'Need to be settled separately from other goods',
  shopCart03: 'Vinie supply chain',
    yourCart: 'Your Cart',
    checkTheCart: 'Add the Cart',
    checkOrderInfo: 'View the List',
    placeTheOrder: 'Place the Order',
    selectAll: 'select all',
    departemployeeText:' has resignated, please remove first!',
    departemployeeTip:'The employee has resigned and cannot be selected!',
    product: 'product',
    specification: 'specification',
    price: 'price',
    quantity: 'quantity',
    ExtPrice: 'Ext. Price',
    ExtPrice2: 'Ext. Price',
    noGoods: 'no goods in this area',
    pleaseChoose: 'Please choose',
    state: 'state',
    stock: 'Stock',
    operation: 'operation',
    delete: 'delete',
    total: 'total',
    proceedToOrder: 'Buy now',
    contactInfo: 'Contact Info',
    addYourAddressFirst: 'Add your contact address',
    addAnAddress: 'add an address',
    checkTheOrder: 'Check The Order',
    PricesForCustom: 'Prices For Custom',
    discounts: 'discounts',
    Credits: enCreditsText,
    YourCurrentPoint: 'your current Credits are',
    YourCurrentPoint2: '',
    youCouldUse: 'you could use',
    thisTime: 'this time',
    coupons: 'coupons',
    available: 'available',
    noUsingOfCoupons: 'no using of coupons',
    delivery: 'Delivery Fee',
    freight: 'freight',
    support: 'Support',
    paymentMethod: 'Payment Method',
    youHaveToPay: 'you have to pay',
    orderInfo: 'order info',
    productsPrice: 'products',
    freightPrice: 'freight',
    discountsPrice: 'discounts',
    proceedToOrder2: 'Buy now',
    price2: 'Price',
    fuli: 'Good grain',
    distributionTo: 'Distribution',
    inStock: 'In stock',
    outStock: 'out stock',
    pts: enCreditsText,
    quantity2: 'Quantity',
    addToCart: 'add to cart',
    productIsSoldOut: 'Goods out of stock',
    productInfo: 'Product Info',
    afterSalesService: 'After Sales Service',
    hello: 'Hello',
    yourCurrentPo: '，',
    hdPoint: '',
    yourOrders: 'My Orders',
    yourAccount: 'My Account',
    welcome: 'Welcome',
    benefitModules: 'Benefit Modules',
    accountManagement: 'account management',
    changePassword: 'password',
    close:'close',
    Ques: {
        OrderingGuide: 'Ordering Guide',
        MemberAccount: 'Member Account',
        OrderMethods: 'Order Methods',
        PaymentTerms: 'Payment Terms',
        ReturnsReplacements: 'Returns & Replacements',
        CarrierInformation: 'Carrier Information',
        PaymentDelivery: 'Payment & Delivery',
        PaymentMethods: 'Payment Methods',
        DeliveryTimes: 'Delivery Times',
        DeliveryAreas: 'Delivery Areas',
        CheckSign: 'Check & Sign',
        CustomerCenter: 'Customer Center',
        TermsofUse: 'Terms of Use',
        RulesofPoints: 'Rules of ' + enCreditsText,
        GuaranteePolicy: 'Guarantee Policy',
        InformationProtection: 'Information Protection',
        AboutUs: 'About Us',
        Clients: 'Clients',
        LegalNotice: 'Legal Notice',
        ContactUs: 'Contact Us'
    },
    fuliCo: '©Fuli Co., Ltd 2013-2019 All Rights Reserved',
    Screening: 'Screen',
    PriceLow: 'Price: Low to High',
    PriceHigh: 'Price: High to Low',
    SaleLow: 'Sales Volume: Low to High',
    SaleHigh: 'Sales Volume: High to Low',
    NewArrival: 'New Arrivals',
    Category: 'Category',
    Help: 'Help',
    CompanyIntro: 'Company Introduce',
    specialRecommend: 'special recommend',
    Discounts: 'Discounts',
    Search: 'Search',
    LowPrice: 'Low Price',
    WorryfreeAftersalesService: 'Worry-free After-sales Service',
    QualityGuarantee: 'Quality Guarantee',
    StandardCredits: 'Standard ' + enCreditsText,
    FestivalCredits: festival + enCreditsText,
    aonCredits: aon + 'credits',
    aonCreditsNo:aon + ' credits has no details',
    aonCreditsText: aon+' credits are credits data of '+aon+' platform. Please log in '+aon+' platform for real-time consumption data.',
    creditsChane:'The ' + enCreditsText+' can be selected for deduction',
    fixNav: {
        Coupon: 'Coupon',
        Cart: 'Cart',
        Credits: enCreditsText == 'credits'?'Credits':enCreditsText,
        Orders: 'Orders',
        QRCode: 'QR Code',
        applet:'Mini Program',
        Tencent:'Official account',
        scanQRCode: 'scan QR Code',
        followthewechatofficialaccount: 'follow the wechat official account',
        onlinecustomerservice: 'online customer service',
        onlinetime: 'online time',
        customerservice: 'Customer service',
        contactcustomerservice: 'contact customer service',
        callcenter: 'call center',
        workingday: 'working day',
        yourID: 'your ID/Company ID',
        pleasefeedbacktothecustomerservicepeople: 'please feedback to the customer service people',
        top: 'top'
    },
    newaddress: 'Add Address',
    editAddress: 'Edit Address',
    addressinformation: 'address information',
    Townshipstreet: 'township street',
    addressdetail: 'address detail',
    consigneename: 'consignee name',
    phoneNo: 'phone No',
    identitycard: 'identity card',
    defaultaddress: 'default address',
    save: 'save',
    cancel: 'cancel',
  suggest:{
    construction_content:'construction content',
    suggested_type: 'Suggested that type',
    status:'status',
    see_feedback: 'See the feedback',
    have_acccepted: 'have acccepted',
    being_processed: 'being processed',
    complaints_immediately: 'Immediate complaint suggestion',
    reply_content: 'reply content',
    upload_pictures: 'upload pictures',
    suggest_tip1: 'The recommended size is 350*120 and only JPG/PNG/BMP files can be uploaded, and a single file should not exceed 3M',
    suggest_tip2: 'Every feedback from you is a powerful support to us!Thank you for your participation!',
    submissions: 'submissions',
    complaints_time: 'Complaints of time',
    complaint_category: 'The complaint category',
    complaint_content: 'complaint content',
    documentary_evidence: 'documentary evidence',
    advice_feedback: 'Advice feedback',
    suggest_tip3: 'We have received your Suggestions, and we will send you the relevant questions and contents as soon as possible.Thank you for your support!',
    goBack: 'go back',

  },
    MY: {
        myaccount: 'my account',
        ordercenter: 'order center',
        myorders: 'my orders',
        customercenter: 'customer center',
        complaint_advice: 'complaint and advice',
        mydiscountcoupon: 'my discount coupon',
        myaftersalesservice: 'my after-sales service',
        myElectronicCard: 'my electronic card',
        accountcenter: 'account center',
        mycredits: 'my ' + enCreditsText,
        deliveryaddress: 'delivery address'
    },
    Profile: {
        accountinformation: 'account information',
        basicinformation: 'basic information',
        realname: 'real name',
        userID: 'user ID',
        company: 'company',
        phoneno: 'phone no.',
        changePasswordNow: 'change password now'
    },
    startorder: 'buy now',
    Order: {
        orderNo: 'order No.',
        picture: 'picture',
        productname: 'product name',
        specifications: 'specifications',
        totalprice: 'total price',
        status: 'status',
        operation: 'operation',
        details: 'details',
        orderinformation: 'order information',
        details2: 'details',
        shippingfee: 'shipping fee',
        tax: 'tax',
        coupon: 'coupon',
        creditpoint: enCreditsText + ' point',
        actualpayment: 'actual payment',
        paymenttime: 'payment time',
        ordertime: 'order time',
        productlist: 'product list',
        productpicture: 'product picture',
        price: 'price',
        quantity: 'quantity',
        shippinginformatio: 'shipping informatio',
        checkshippinginformation: 'check shipping information',
        address: 'address',
        consignee: 'consignee',
        address2: 'address',
        contact: 'contact',
        remarks: 'Remarks',
        Pleasefillintheordernotes: 'Please fill in the order notes',
        shipCompany: 'logistics company',
        shipOrderNo: 'express number',
        noLogisticsInfo: 'No logistics information',
        deliveryNote: 'delivery note',
        previousOrderQueryBtn: 'Previous order query search,please click',
        previousOrderQuery: 'Previous Order Query',
        checkCardPwd: 'View Card Password',
        couponDeduction: 'coupon deduction',
        orderPrice: 'order price',
    },
  confirm_03_0: 'There is an unpaid order in your order, you can enjoy the deduction after the completion of the settlement of the unpaid order.',
    succeed: 'succeed',
    orderNo: 'order No.',
    amount: 'amount',
    payment: 'payment',
    paybycredits: 'paybycredits',
    alipay: 'Alipay',
    Alipay: 'Alipay',
    WeChat: 'WeChat',
    WeChatPayment: 'WeChat Pay',
    topay: 'To Pay',
    check: 'check',
    availablePoint: 'available',
    none: 'none',
    payNow: 'pay',
    cancelOrder: 'cancel',
    applyReturn: 'apply return',
    ConfirmReceipt: 'confirm receipt',
    confirmPay: 'confirm pay',
    afterSale: 'after sale',
    loginOut: 'login out',
    index: 'Home Page',
    integral: enCreditsText,
    outStockProdTip: 'The goods has been off the shelves, please choose other goods!',
    seckillPrice: 'Seckill Price',
    originalPrice: 'Original Price',
    creditsDeduction: enCreditsText+' Deduction',
    receiveImmediately: 'Receive Immediately',
    toUse: 'To Use',
    received: 'can use {0}',
    receivedAgain: 'Received Again',
    noCouponTip: 'Coupons activities are not open!',
    placeWait: 'Please wait patiently',
    noCouponProdTip: 'Your company has been to limit such goods!',
    noCouponProdTip2: 'Would you please check other coupons activities!',
    virtualGoodsTip: 'The goods is virtual goods, unable to return, please check the goods details!',
    buyNow: 'buy now',
    timeRemaining: 'time remaining',
    seckillEnd: 'The SEC has ended',
    noSeckillTip: 'Seckill activities are not open!',

    approve:'approve',
}



// WEBPACK FOOTER //
// ./src/config/EN.js